import Folder from '@mui/icons-material/Folder';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FolderIcon(props: FixMe) {
  return <Folder {...props} />;
}

export default FolderIcon;
